import client from '../httpClient';

const customerDeleteShareApi = (params) => {
  return client.put('/customers/share/delete', JSON.stringify(params));
};

export default customerDeleteShareApi;
